<div class="value-prop-wrapper centered" [ngClass]="{
  'svg-label': svgLabel,
  'checkmark-primary': isCheckmarkPrimary,
  'single-click-plans': isSingleClickPlans
}">
  <flo-svg-icon
    *ngIf="svgLabel && (label === 'checkmark' || isSingleClickPlans)"
    class="d-flex svg-wrapper checkmark svg-vertical-align-text-top"
    [ngClass]="{
      'single-click-plans': isSingleClickPlans
    }"
    icon="icon-check-mark"
    [width]="svgWidth">
  </flo-svg-icon>
  <flo-svg-icon
    *ngIf="svgLabel && label === 'checkmark-green'"
    class="d-flex svg-wrapper checkmark money-green svg-vertical-align-text-top"
    icon="icon-check-mark"
    [width]="svgWidth">
  </flo-svg-icon>
  <flo-svg-icon
    *ngIf="svgLabel && isCheckmarkPrimary"
    class="d-flex svg-wrapper checkmark-primary svg-vertical-align-text-top"
    icon="icon-check-mark"
    [width]="svgWidth">
  </flo-svg-icon>
  <flo-svg-icon
    *ngIf="svgLabel && label === 'x-mark'"
    class="d-flex svg-wrapper x-mark"
    width="24"
    icon="icon-times">
  </flo-svg-icon>
  <div *ngIf="!svgLabel" class="text-label subheader">
    {{ label }}
  </div>
  <p 
  [ngClass]="{ 
    'value-prop': true, 
    'checkmark-primary-value-prop': isCheckmarkPrimary,
    'single-click-value-prop': isSingleClickPlans 
  }"
  [innerHTML]="safeProposition">
    
  </p>
</div>
